import { LocalizationManager } from "../localization/localization_manager.js";

/** Timed rewards carry minutes in `amount`, not a count. */
export function isTimedRewardType( type: string ): boolean
{
  return type === "infinite_hearts" || type === "no_ads";
}

/**
 * infinite_hearts and no_ads are timed rewards: their amount is minutes, so
 * they read "30м" instead of the countable "x30" the other reward types use.
 */
export function rewardAmountText( type: string, amount: number ): string
{
  if ( isTimedRewardType( type ) )
    return `${amount}${LocalizationManager.t( "TIME.SHORT_MINUTES" )}`;
  return `x${amount}`;
}

/** "1г 30хв" / "2г" / "45хв" — the offer-card form of a minutes amount. */
export function formatMinutesShort( total_minutes: number ): string
{
  const hours = Math.floor( total_minutes / 60 );
  const minutes = total_minutes % 60;
  const h = LocalizationManager.t( "TIME.SHORT_HOURS" );
  const m = LocalizationManager.t( "TIME.SHORT_MINUTES" );
  return hours && minutes ? `${hours}${h} ${minutes}${m}` : hours ? `${hours}${h}` : `${minutes}${m}`;
}
